// ============================================================================
// OBT (Operasyonel Bilgi Toplama) — Rol ve erişim sabitleri
// ============================================================================
// KAYNAK: backend/modules/obt/scope.py (ROLE_* sabitleri, PUBLISHER_ROLES,
// TARGETABLE_ROLES) ve backend/modules/obt/reporting.py
// (_REPORT_DENIED_ROLES). Burada YENİ rol adı türetilmez; yalnız backend'de
// gerçekten var olan slug'lar yeniden kullanılır.
//
// ÖNEMLİ: OBT'nin backend tarafında permission slug'ı (`obt.gor` gibi) YOKTUR.
// Yetkilendirme tamamen rol + ChainService kapsamı üzerinden yapılır. Bu
// nedenle menü ve sekme görünürlüğü de rol tabanlıdır; var olmayan bir slug'a
// bağlanamaz.
//
// Bu dosyadaki kontroller YALNIZ kullanıcı deneyimi içindir. Gerçek yetki
// backend'dedir (JWT + personnel tablosundan okunan rol + zincir kapsamı);
// frontend hiçbir koşulda rol/scope üretmez, yalnız doğrulanmış auth
// kaynağından okur.
// ============================================================================

export const OBT_ROLE_MUDUR = 'mudur';
export const OBT_ROLE_MUDUR_YARDIMCISI = 'mudur_yardimcisi';
export const OBT_ROLE_BOLGE_MUHENDISI = 'bolge_muhendisi';
export const OBT_ROLE_FORMEN = 'formen';
export const OBT_ROLE_PARK_GOREVLISI = 'park_gorevlisi';

/**
 * OBT arayüzüne erişebilen roller.
 *
 * Backend `reporting.py` yalnız `park_gorevlisi`yi açıkça reddeder; ancak OBT
 * iş akışı BelVizyon personel hiyerarşisine (Müdür → MY → BM → Formen)
 * bağlıdır. Hiyerarşi dışındaki roller (admin, baskan, cim_ekibi, gorevli...)
 * için OBT'de tanımlı bir görev yoktur; ürün kuralı gereği sekme
 * gösterilmez.
 */
export const OBT_ALLOWED_ROLES = Object.freeze([
  OBT_ROLE_MUDUR,
  OBT_ROLE_MUDUR_YARDIMCISI,
  OBT_ROLE_BOLGE_MUHENDISI,
  OBT_ROLE_FORMEN,
]);

/** Kampanya yayınlayabilen roller — backend `scope.PUBLISHER_ROLES` ile birebir. */
export const OBT_PUBLISHER_ROLES = Object.freeze([
  OBT_ROLE_MUDUR,
  OBT_ROLE_MUDUR_YARDIMCISI,
  OBT_ROLE_BOLGE_MUHENDISI,
]);

/** Cevap veren (hedeflenebilir) roller — backend `scope.TARGETABLE_ROLES`. */
export const OBT_TARGETABLE_ROLES = Object.freeze([
  OBT_ROLE_MUDUR_YARDIMCISI,
  OBT_ROLE_BOLGE_MUHENDISI,
  OBT_ROLE_FORMEN,
]);

/**
 * Verilen rol OBT arayüzünü görebilir mi?
 * Fail-closed: tanımsız/boş/bilinmeyen rol → false.
 */
export function canAccessObt(role) {
  if (typeof role !== 'string' || role.length === 0) return false;
  return OBT_ALLOWED_ROLES.includes(role);
}

/** Rol kampanya yayınlayabilir mi (F2'de kullanılacak). */
export function canPublishObt(role) {
  if (typeof role !== 'string' || role.length === 0) return false;
  return OBT_PUBLISHER_ROLES.includes(role);
}

/**
 * Rolün OBT panelindeki görünümü. Panel seçimi bu değere göre yapılır;
 * bileşen içinde uzun koşul zincirleri kurulmaz.
 */
export function obtDashboardKindForRole(role) {
  switch (role) {
    case OBT_ROLE_MUDUR:
      return 'director';
    case OBT_ROLE_MUDUR_YARDIMCISI:
      return 'deputy';
    case OBT_ROLE_BOLGE_MUHENDISI:
      return 'engineer';
    case OBT_ROLE_FORMEN:
      return 'foreman';
    default:
      return null;
  }
}
